"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = require("./resource");
var DeviceStatusEvent = /** @class */ (function (_super) {
    __extends(DeviceStatusEvent, _super);
    function DeviceStatusEvent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deviceId = null;
        _this.organization = null;
        _this.driver = null;
        _this.data = {};
        _this.createdAt = null;
        _this.locationAuthorization = null;
        _this.lowPowerMode = null;
        _this.lowDeviceStorage = null;
        _this.backgroundAppRefresh = null;
        _this.applicationName = null;
        _this.applicationVersion = null;
        _this.deviceOS = null;
        _this.signal = null;
        _this.battery = null;
        return _this;
    }
    return DeviceStatusEvent;
}(resource_1.Resource));
exports.DeviceStatusEvent = DeviceStatusEvent;
